import React from "react";
import "../../../../styles/customize-components/bulk-action-btns.css";

const BulkAssignButtons = ({
  heading = "Bulk Actions",
  submitText = "Submit",
  cancelText = "Cancel",
  onSubmit,
  onCancel,
  disabled = false,
  loading = false,
}) => {
  return (
    <div className="bulk-action-container">
      <div className="bulk-action-header">
        <h3 className="bulk-action-heading">{heading}</h3>
      </div>

      <div className="bulk-action-buttons">
        <button
          className="bulk-action-btn bulk-action-btn-submit"
          onClick={onSubmit}
          disabled={disabled || loading}
        >
          {loading ? "Processing..." : submitText}
        </button>

        <button
          className="bulk-action-btn bulk-action-btn-cancel"
          onClick={onCancel}
          disabled={disabled || loading}
        >
          {cancelText}
        </button>
      </div>
    </div>
  );
};

export default BulkAssignButtons;
